import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly isOpen: boolean;
  readonly isPending?: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
};

export const ProposedSolutionDeleteDialog = ({ isOpen, isPending, onClose, onConfirm }: Props) => {
  const { t } = useResource();

  return (
    <DialogModal
      isOpen={isOpen}
      onClose={onClose}
      title={t(Resources.AnalysisDetail.GoalsFulfillment.DeleteProposedSolutionTitle)}
      subtitle={t(Resources.AnalysisDetail.GoalsFulfillment.DeleteProposedSolutionText)}
      primaryAction={
        <Button disabled={isPending} onClick={onConfirm}>
          {t(Resources.Common.Yes)}
        </Button>
      }
    />
  );
};
